import { Injectable } from '@angular/core';
import type { StatusFindInterface } from '@zaoblako/shared/modules/project/dto/status/status-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectStatusService extends BaseService {
  protected baseUrl = '/project/status';

  /** @deprecated Use status list with pagination API */
  public all(): Observable<StatusFindInterface[]> {
    return this.http.get<StatusFindInterface[]>(`${this.baseUrl}/all`);
  }
}
